import React, { useState, useEffect } from 'react';
import { Modal } from '@mantine/core';
import { modals } from '@mantine/modals';
import styles from './index.modules.scss';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { Text, Input, Radio } from '@shakkerai/pro-components';

/**
 * 创建模态框，模态框中包含一个输入框
 *
 * @param {*} props
 * @returns
 */
export const CreateModal = (props) => {
  const { onConfirm, value, placeholder, ...restProps } = props;
  const [innerValue, setValue] = useState(value);

  useEffect(() => {
    if (restProps.opened) {
      setValue('');
    }
  }, [restProps.opened]);

  return (
    <CommonModal onConfirm={() => onConfirm(innerValue)} {...restProps}>
      <Input placeholder={placeholder} value={innerValue} onChange={(event) => setValue(event.currentTarget.value)} />
    </CommonModal>
  );
};

/**
 * 确认模态框，模态框中包含一段说明文本
 *
 * @param {*} props
 * @returns
 */
export const ConfirmModal = (props) => {
  const { content, subcontent, ...restProps } = props;

  return (
    <CommonModal {...restProps}>
      <>
        <div className="flex gap-[8px] items-center">
          <Icon className="icon-proExclude" color="#F9B959" fontSize={24}></Icon>
          <div className={styles.mainContent}>{content}</div>
        </div>
        <div className={`${styles.subContent} ml-[32px]`}>{subcontent}</div>
      </>
    </CommonModal>
  );
};

export const showConfirmModal = (props) => {
  const { title, message, comfirmText, cancelText } = props;

  return new Promise((resolve) => {
    const hostNode = document.createElement('div');
    document.body.appendChild(hostNode);

    const closeModal = () => {
      modals.close('confirm-modal');
    };

    const handleCancel = () => {
      closeModal();
      resolve(false);
    };

    const handleConfirm = () => {
      closeModal();
      resolve(true);
    };

    modals.open({
      modalId: 'confirm-modal',
      withCloseButton: false,
      children: (
        <>
          <div className="flex gap-[8px] items-center">
            <Icon className="icon-proExclude" color="#F9B959" fontSize={24}></Icon>
            <div className={styles.mainContent}>{title}</div>
          </div>
          <div className={`${styles.subContent} ml-[32px]`}>{message}</div>
          <div className={`${styles.bottomC} mt-[38px]`}>
            <div className={styles.comfirm} onClick={handleConfirm}>
              {comfirmText || translate('confirm')}
            </div>
            <div onClick={handleCancel} className={styles.cancel}>
              {cancelText || translate('cancel')}
            </div>
          </div>
          <Icon className={`icon-border_close ${styles.close}`} color="#5C636B" fontSize={16} onClick={handleCancel} />
        </>
      ),
    });
  });
};

/**
 * 带勾选的确认框
 *
 * @param {*} props
 * @returns
 */
export const SeleteConfirmModal = (props) => {
  const { content, onConfirm, subcontent, ...restProps } = props;
  const [checked, setChecked] = useState(false);

  return (
    <CommonModal {...restProps} onConfirm={() => onConfirm(checked)}>
      <>
        <div className="flex gap-[8px] items-start">
          <Icon className="icon-proExclude relative -top-[6px]" color="#F9B959" fontSize={24}></Icon>
          <div className={styles.mainContent}>{content}</div>
        </div>
        <div className="flex mt-3 ml-[32px]">
          <Radio checked={checked} className={`mr-1 ${styles.radio}`} onClick={() => setChecked(!checked)}></Radio>
          <div className={`${styles.subContent}`}>{subcontent}</div>
        </div>
      </>
    </CommonModal>
  );
};

/**
 * 统一标准的模态框
 * @param {*} props
 * @returns
 */
export const CommonModal = (props) => {
  const {
    onConfirm,
    onClose,
    children,
    title,
    comfirmText = translate('comfirm'),
    cancelText = translate('cancel'),
    ...restProps
  } = props;
  return (
    <Modal
      {...restProps}
      onClose={onClose}
      centered
      withCloseButton={false}
      className={`${styles.modal}`}
      data-role="gen-history-trigger"
    >
      {title && (
        <Text fw={500} iconClass="icon-protab" iSize={24} size={20} color="var(--color-primary-dark)" className="mb-5">
          {title}
        </Text>
      )}

      {children}

      <div className={`${styles.bottomC} mt-[38px]`}>
        <div className={styles.comfirm} onClick={onConfirm}>
          {comfirmText}
        </div>
        <div onClick={onClose} className={styles.cancel}>
          {cancelText}
        </div>
      </div>
      <Icon className={`icon-border_close-1 ${styles.close}`} color="#5C636B" fontSize={16} onClick={onClose}></Icon>
    </Modal>
  );
};
